import { Button, Flex, Tooltip } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../../../Icon"
import { GROUP_META } from "../../constants/constants"
import { mastercomPriceLine } from "./mastercomPriceLine"

import styles from "./program-card.module.less"

export const ProgramCard = ({
  program,
  onAdd,
  disabled,
  disabledReason,
  codesToggleLabel,
  onCodesToggle
}) => {
  const { t } = useTranslation()
  const groupMeta = GROUP_META[program.status] || GROUP_META.not_enrolled
  const at = program.characteristics?.activation_time || { value: "", unit: "" }
  const chargebackNetworks = program.characteristics?.prevents_chargebacks_for || []
  // Consumer Clarity only — Order Insight has no Mastercom price to quote (CHA1-3168).
  const mastercom = mastercomPriceLine(program.prices)

  const addLabel =
    program.program === "cc" ? "Add more descriptors" : "Add descriptors, ARN's, or BIN/CAID"

  return (
    <div className={styles.card} data-testid="deflect-business-program-card">
      <div className={styles.nameStatusBlock}>
        <div className={styles.providerRow}>
          <span className={styles.serviceName}>{program.name}</span>
          {program?.brand && <Icon type={program.brand} className="icon" />}
          <span className={styles.serviceBrand}>
            {/*{program.brand === "mastercard" ? "Mastercard" : "Visa"}*/}
            {program.brand}
          </span>
        </div>
        <div className={`${styles.enrollmentStatus} ${styles[groupMeta.class]}`}>
          {t(groupMeta.label)}
        </div>
      </div>

      <div className={styles.priceBlock}>
        <div className={styles.priceLines}>
          <div className={styles.priceLine}>
            <span className={styles.amount}>${program.prices?.banking_app_lookup}</span>
            <span className={styles.per}>{t("per banking-app lookup")}</span>
          </div>
          <div className={styles.priceLine}>
            <span className={styles.amount}>${program.prices?.call_center_lookup}</span>
            <span className={styles.per}>{t("per call-center lookup")}</span>
          </div>
          {mastercom ? (
            <div className={styles.priceLine}>
              <span className={styles.amount}>${mastercom.amount}</span>
              <span className={styles.per}>{t("per Mastercom lookup")}</span>
            </div>
          ) : null}
        </div>
        {/* Codes-view toggle (BLOCK 5.1): right-aligned next to the price lines.
            The caller renders it only on Order Insight, and only for support. */}
        {codesToggleLabel ? (
          <button
            type="button"
            className={styles.codesToggle}
            onClick={onCodesToggle}
            data-testid="deflect-business-codes-toggle"
          >
            {t(codesToggleLabel)}
          </button>
        ) : null}
      </div>

      <p className={styles.description}>{t(program.description)}</p>

      <div className={styles.divider} />

      <div className={styles.characteristics}>
        <div className={styles.characteristicRow}>
          <span className={styles.label}>{t("Coverage")}</span>
          <span className={styles.value}>{t(program.characteristics?.coverage || "")}</span>
        </div>
        <div className={styles.characteristicRow}>
          <span className={styles.label}>{t("Chargeback fee saved")}</span>
          <span className={styles.value}>~${program.characteristics?.chargeback_fee_saved}</span>
        </div>
        <div className={styles.characteristicRow}>
          <span className={styles.label}>{t("Activation time")}</span>
          <span className={styles.value}>
            ~{at.value} {t(at.unit)}
          </span>
        </div>
        <div className={styles.characteristicRow}>
          <span className={styles.label}>{t("Prevents chargebacks for")}</span>
          {/*<span className={styles.value}>{chargebackNetworks2}</span>*/}
          <Flex gap={8}>
            {chargebackNetworks.map((n) => (
              <Icon key={n} type={n} />
            ))}
          </Flex>
        </div>
      </div>

      <div className={styles.cardFooter}>
        <Tooltip title={disabled && disabledReason ? t(disabledReason) : ""}>
          <Button
            type="primary"
            size="large"
            className={styles.addButton}
            onClick={onAdd}
            disabled={disabled}
            data-testid="deflect-business-add-descriptors-btn"
          >
            + {t(addLabel)}
          </Button>
        </Tooltip>
      </div>
    </div>
  )
}
